<div class="suggestion-container">
  <!-- Results Table -->
  <div class="table-wrapper" *ngIf="!loading && allSuggestions.length">
    <p style="padding:10px 20px 10px 20px; margin-bottom: 0px;">Results</p>
    <table>
      <tbody>
        <tr *ngFor="let result of allSuggestions" (click)="rowSelected(result)">
          <td style="color: rgba(60, 60, 60, 1);font-weight: bold;">{{result.title}}</td>
          <!-- <td style="color: rgba(60, 60, 60, 1);">{{result.item2}}</td> -->
          <td style="color: rgba(60, 60, 60, 1);">{{getStandardTypeName(result.standardTypeId)}}</td>

        </tr>
      </tbody>
    </table>
  </div>

  <!-- No items found -->
  <div *ngIf="!loading && !allSuggestions.length" class="table-wrapper" style="height:50px;display: flex;flex-direction:row;justify-content:space-between; align-items: center;">
    <div style="margin-left: 5px;">
      <!-- <img src="../../assets/images/magnifier-slash 1.png" alt="empty"/> -->
      <p style="font-size: 15px;margin: 0;">For all results related <Span style="font-weight: bold;">"{{query}}"</Span></p>
      <!-- <p style="font-size: 12px;margin: 0;">Try with different keyword</p> -->
    </div>
    <div style="display: flex;align-items: center;margin-right: 10px;">
        <p style="margin: 0;">Press</p>
        <div (click)="apply()" style="cursor: pointer;margin-left: 5px;border-radius: 3px; background-color: #3F51B51F;padding: 3px 6px 3px 6px;font-weight: bold;color: #3F51B5;">
          <img src="../../assets/images/Enter svg.svg" alt="enter logo"/>
        </div>
    </div>
  </div>

  <!-- Loader -->
  <div class="suggestion-container" *ngIf="loading">
    <div class="table-wrapper">
      <div style="height:300px;display: flex;flex-direction:column;justify-content: center ;align-items: center;">
        <mat-spinner [diameter]="40"></mat-spinner>
      </div>
    </div>
  </div>
</div>
